import { GoogleLogin } from "@react-oauth/google";
import { useGoogleLogin } from "@react-oauth/google";
import { Header } from "./Header.";
import Footer from "./Footer";
import "./Styles/login.css";
import React, { useEffect, useState } from "react";
import LoginLoader from "../Images/login-filter.gif";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "universal-cookie";
import {
  addProductInCart,
  addProductInFavourites,
  setCart,
  setCartID,
} from "../Services/localStorage";
// import {
//   FacebookLoginButton,
//   GoogleLoginButton,
//   GithubLoginButton,
//   AmazonLoginButton,
//   InstagramLoginButton,
//   LinkedInLoginButton,
//   MicrosoftLoginButton,
//   TwitterLoginButton,
//   AppleLoginButton,
// } from 'react-social-login-buttons';
import googleLogo from "../Images/google-logo.png";
import fbLogo from "../Images/fblogo.png";
import { LoginSocialFacebook } from "reactjs-social-login";
import moment from "moment/moment";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const cookies = new Cookies();
  const queryParameters = new URLSearchParams(window.location.search);

  const loginGoogle = useGoogleLogin({
    onSuccess: async (respose) => {
      try {
        const res = await axios.get(
          "https://www.googleapis.com/oauth2/v3/userinfo",
          {
            headers: {
              Authorization: `Bearer ${respose.access_token}`,
            },
          }
        );
        login(
          "google",
          res.data.email,
          res.data.given_name,
          res.data.family_name,
          "0000000000",
          res.data.sub + "1KbA"
        );
      } catch (err) {
        console.log(err);
      }
    },
  });
  function loginFacebook(res) {
    login(
      "facebook",
      res.data.email !== "" ? res.data.email : res.data.id + "@facebook.fr",
      res.data.last_name,
      res.data.first_name,
      "0000000000",
      res.data.id + "1KbA"
    );
  }
  var redirectTo =
    queryParameters.get("redirectTo") !== null
      ? queryParameters.get("redirectTo")
      : "/";

  document.title = "Se Connecter - KabaaShop";

  const login = (
    typeConnexion = "normal",
    emailAuth = "",
    firstname = "",
    lastname = "",
    phoneAuth = "",
    passwordAuth = ""
  ) => {
    setLoading(true);
    let stringConnect =
      process.env.REACT_APP_API_BASE_URL +
      "/login?email=" +
      email +
      "&password=" +
      password;
    if (typeConnexion !== "normal") {
      stringConnect =
        process.env.REACT_APP_API_BASE_URL +
        "/login?email=" +
        emailAuth +
        "&password=" +
        passwordAuth;
    }

    axios
      .post(
        stringConnect,
        {},
        {
          headers: {
            "x-api-token": process.env.REACT_APP_API_TOKEN,
          },
        }
      )
      .then((a) => {
        if (a.data.favs) {
          a.data.favs.forEach((f) => {
            addProductInFavourites(f);
          });
        }
        //search card order status
        axios
          .get(
            process.env.REACT_APP_API_BASE_URL +
              "/api/orders/" +
              a.data.id +
              "?status=cart",
            {
              headers: {
                "x-api-token": process.env.REACT_APP_API_TOKEN,
              },
            }
          )
          .then((x) => {
            if (a.data.mailConfirmedAt == null) {
              if (x.data.id) {
                cookies.set("cart_temp", x.data, { path: "/" });
              }

              cookies.set("user_temp", a.data, { path: "/" });

              toast.info(
                "Vous devez confirmer votre adresse email avant de continuer. Vous serez rediriger dans un instant !"
              );

              setTimeout(() => {
                window.location.href = "/MailConfirmation";
              }, 2500);
            } else {
              if (x.data.id) {
                setCartID(x.data.id);
                x.data.orderedProducts.forEach((op) => {
                  addProductInCart(op.product, op.quantity);
                });
              }
              setLoading(false);
              cookies.set("user", a.data, { path: "/", expires: moment().add(1, 'months').toDate() });
              toast.success(
                "Connexion réussie ! Vous serez rediriger dans un instant."
              );
              setTimeout(() => {
                window.location.href = redirectTo;
              }, 2500);
            }
          })
          .catch((error) => {
            setLoading(false);

            if (error.response.data.detail == "Not Found") {
              if (a.data.mailConfirmedAt == null) {
                cookies.set("user_temp", a.data, { path: "/" });

                toast.info(
                  "Vous devez confirmer votre adresse email avant de continuer. Vous serez rediriger dans un instant !"
                );

                setTimeout(() => {
                  window.location.href = "/MailConfirmation";
                }, 2500);
              } else {
                cookies.set("user", a.data, { path: "/", expires: moment().add(1, 'months').toDate() });
                toast.success(
                  "Connexion réussie ! Vous serez rediriger dans un instant."
                );
                setTimeout(() => {
                  window.location.href = redirectTo;
                }, 2500);
              }
            } else {
              if (
                error.response.data === "No User Found" ||
                error.response.data === "Password Invalid"
              ) {
                toast.error("Email ou mot de passe non correct !");
              } else {
                toast.error("Une erreur est survenue ! veuillez réessayer !");
              }
              setLoading(false);
            }
          });
      })
      .catch((error) => {
        console.log(error);
        if (
          error.response.data === "No User Found" ||
          error.response.data === "Password Invalid"
        ) {
          if (typeConnexion !== "normal") {
            let data = {
              firstname: firstname,
              lastname: lastname,
              password: passwordAuth,
              email: emailAuth,
              isEnable: true,
              contact: phoneAuth,
            };

            axios
              .post(process.env.REACT_APP_API_BASE_URL + "/api/users", data, {
                headers: {
                  "x-api-token": process.env.REACT_APP_API_TOKEN,
                },
              })
              .then((a) => {
                axios
                  .post(
                    process.env.REACT_APP_API_BASE_URL +
                      "/login?email=" +
                      emailAuth +
                      "&password=" +
                      passwordAuth,
                    {},
                    {
                      headers: {
                        "x-api-token": process.env.REACT_APP_API_TOKEN,
                      },
                    }
                  )
                  .then((b) => {
                    if (b.data.mailConfirmedAt == null) {
                      cookies.set("user_temp", b.data, { path: "/" });

                      toast.info(
                        "Vous devez confirmer votre adresse email avant de continuer. Vous serez rediriger dans un instant !"
                      );

                      setTimeout(() => {
                        window.location.href = "/MailConfirmation";
                      }, 2500);
                    } else {
                      cookies.set("user", b.data, { path: "/", expires: moment().add(1, 'months').toDate() });

                      toast.success(
                        "Bienvenue dans la famille KabaaShop ! Vous serez rediriger dans un instant."
                      );
                      setTimeout(() => {
                        window.location.href = "/";
                      }, 2500);
                    }

                    setLoading(false);
                  })
                  .catch((error) => {
                    console.log(error);
                    setLoading(false);
                    toast.error(
                      "Une erreur est survenue ! veuillez réessayer !"
                    );
                  });
              })
              .catch((error) => {
                if (error.response.status == 422) {
                  toast.error("Un compte a déjà été créé avec cette adresse !");
                } else {
                  toast.error(
                    "Une erreur est survenue ! Veuillez réessayer plus tard !"
                  );
                }

                setLoading(false);
              });
            return;
          }
          toast.error("Email ou mot de passe non correct !");
        } else {
          toast.error("Une erreur est survenue ! veuillez réessayer !");
        }
        setLoading(false);
      });
  };

  return (
    <>
      <ToastContainer />
      <Header />
      <div className="login-main">
        <div className="login">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              login();
            }}
          >
            <p className="login-label">Connexion</p>
            <input
              disabled={loading}
              className="login-input"
              type="email"
              placeholder="Adresse Email"
              required
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <input
              disabled={loading}
              className="login-input"
              type="password"
              placeholder="Mot de passe"
              required
              onChange={(e) => {
                setPassword(e.target.value);
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: "10px",
              }}
            >
              <button disabled={loading} className="login-button">
                <span
                  style={{ display: loading ? "none" : "block" }}
                  className="login-btn-text"
                >
                  Se Connecter
                </span>
                <span
                  style={{ display: loading ? "block" : "none" }}
                  className="login-btn-img"
                >
                  <img src={LoginLoader} alt="loading"/>
                </span>
              </button>
            </div>
          </form>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <button
              disabled={loading}
              onClick={loginGoogle}
              style={{
                backgroundColor: "black",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
                gap: "10px",
                padding: "10px",
                fontSize: "1em",
                boxSizing: "border-box",
                borderRadius: "10px",
                width: "275px",
              }}
            >
              <img
                src={googleLogo}
                style={{ height: "30px", aspectRatio: "1/1" }}
                alt="g-icon"
              />
              <span style={{ flex: 1, textAlign: "center" }}>
                Connexion avec google
              </span>
            </button>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "10px",
            }}
          >
            <LoginSocialFacebook
              appId="591485485812656"
              onResolve={(response) => {
                loginFacebook(response);
              }}
              onReject={(response) => {
                toast.error("Une erreur est survenue ! veuillez réessayer !");
              }}
            >
              <button
                disabled={loading}
                // onClick={loginGoogle}
                style={{
                  backgroundColor: "black",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: "row",
                  gap: "10px",
                  padding: "10px",
                  fontSize: "1em",
                  boxSizing: "border-box",
                  borderRadius: "10px",
                  width: "275px",
                }}
              >
                <img
                  src={fbLogo}
                  style={{ height: "30px", aspectRatio: "1/1" }}
                  alt="g-icon"
                />
                <span style={{ flex: 1, textAlign: "center" }}>
                  Connexion avec Facebook
                </span>
              </button>
              {/* <FacebookLoginButton /> */}
            </LoginSocialFacebook>
          </div>

          <p className="login-p">
            Mot de passe oublié ?{" "}
            <a href="/mot-de-passe-oublie" className="login-link">
              Reinitialisez-le
            </a>
          </p>
          <p className="login-p">
            Pas de compte ?{" "}
            <a href="/inscription" className="login-link">
              S'inscrire
            </a>
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};
